import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { AltoComponentsPageComponent } from "./alto-components-page.component";

export const altoComponentsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-alto-components-page", AltoComponentsPageComponent)
    .atUrl("/about/theme-test/alto-components")
    .requiresLogin(true)
    .build();
